import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const Investeringsraadgivning = () => {
  const questions = [
    "Hvordan får jeg det største afkast af mine midler?",
    "Skal jeg indfri gæld eller investere?",
    "Hvad er kriterierne for placering af frie midler?",
    "Er det bedst at spare op i pension eller virksomhed?"
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Investeringsrådgivning: Uvildig rådgivning til investeringer</title>
        <meta name="description" content="Hos os tager investeringsrådgivningen udgangspunkt i at sikre dig det størst mulige afkast med lavest mulige omkostninger baseret på dine mål. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Investeringsrådgivning</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Investeringsrådgivning</h1>

        <div className="flex flex-col md:flex-row gap-10 mb-12">
          <div className="md:w-1/3">
            <img 
              src="https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/47d9bef7-6d57-44d3-b683-1eeb792e2fa5.jpg" 
              alt="investeringsrådgivning" 
              className="rounded-2xl shadow-lg w-full"
            />
          </div>
          <div className="md:w-2/3 prose prose-slate prose-lg">
            <p>
              Vi sikrer dig det størst mulige afkast med de lavest mulige omkostninger. Vi tager højde for din risikovillighed, tidshorisont og skattemæssige situation, uanset om det er private midler eller virksomhedskapital.
            </p>
            <p>
              Vi udarbejder en klar strategi sammen med dig, så du ved præcis, hvordan dine midler er placeret og hvorfor.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {questions.map((q, i) => (
            <div key={i} className="bg-slate-50 p-6 rounded-2xl border border-slate-200 flex items-start">
              <CheckCircle2 className="text-[#b60f00] mr-4 shrink-0 mt-1" size={20} />
              <p className="text-slate-800 font-medium leading-relaxed text-sm">{q}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/kontakt-os" 
            className="inline-flex items-center bg-[#b60f00] text-white px-10 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-md active:scale-95"
          >
            Bestil et gratis uforpligtende møde her
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Investeringsraadgivning;
